<script setup lang="ts">
import type { TWinnersCategory } from '~/interfaces/winners/winnersInterfaces';
import Tabs from '~/components/design-system/tabs/tabs.vue';
import Tab from '~/components/design-system/tabs/tab.vue';
const props = defineProps<{ tabs: ReadonlyArray<TWinnersCategory> }>();
const transformedTabs = computed(() =>
  props.tabs?.map((tab) => ({ ...tab, title: tab.key })),
);
</script>
<template>
  <Tabs
    alternate-bg-colors
    class="bg-layer rounded-xl p-1 mt-6 md:hidden"
    header-container-class="my-2"
  >
    <template v-if="!!transformedTabs" #tabList>
      <Tab
        v-for="tab in transformedTabs"
        :id="tab.key"
        :key="tab.key"
        :title="$t(tab.key)"
      >
        <WinnersCategoryTab :id="tab.key" :key="tab.key" :tab="tab" />
      </Tab>
    </template>
  </Tabs>
</template>
